export default "__VITE_ASSET__Cr2UGR$0__"